import { Module } from './base';
import { getTranslation } from "../components/i18n";
import SettingsPersistor from "../components/settings-persistor";

class StopAnimationsModule implements Module {
  name = 'stop-animations';

  setup(a11ySettings: Record<string, any>, modulesContainer: HTMLElement) {
    const moduleName = this.name;
    let styleContents = `
      .a11y-paused *, .a11y-paused *::before, .a11y-paused *::after {
        animation-fill-mode: forwards !important;
        animation-duration: 0s !important;
        transition: none !important;
      }
      .a11y-paused *:has(* > *:not(img)) {}
      .a11y-paused *:has(img):not(.active) {}
      .a11y-paused *:has(> span), .a11y-paused span, .a11y-paused img {}
    `;
    const stopAnimationsElement = document.createElement("div");
    stopAnimationsElement.className = `a11y-module a11y-module-${moduleName}`;
    stopAnimationsElement.innerHTML = `
      <label id="a11y-${moduleName}-label" for="toggle-${moduleName}" data-translation-field="true" data-translation-key="stopAnimations">${getTranslation('stopAnimations')}</label>
      <label class="a11y-toggle" tabindex="0" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-label-text">
        <span id="a11y-${moduleName}-label-text" class="screen-reader-text">Die Option ist <span class="toggle-state-text"></span></span>
        <input id="toggle-${moduleName}" type="checkbox" tabindex="-1">
        <span class="slider"></span>
      </label>
    `;
    modulesContainer.appendChild(stopAnimationsElement);
    const toggleVideos = (toggle: boolean) => {
      const videos = document.querySelectorAll('video');
      videos.forEach((video) => {
        if (toggle) {
          video.pause();
        } else {
          video.play();
        }
      })
    };
    const stopAnimationsToggle = document.getElementById(`toggle-${moduleName}`) as HTMLInputElement;
    const toggleStateText = stopAnimationsElement.querySelector(`.toggle-state-text`) as HTMLSpanElement;
    stopAnimationsToggle.addEventListener("change", () => {
      toggleStateText.innerText = stopAnimationsToggle.checked ? 'aktiviert' : 'deaktiviert';
      document.body.classList.toggle("a11y-paused", stopAnimationsToggle.checked);
      toggleVideos(stopAnimationsToggle.checked);
      SettingsPersistor.save(moduleName, stopAnimationsToggle.checked);
    });
    // EXPERIMENTAL
    const originalSetTimeout = window.setTimeout;
    window.setTimeout = function (
      handler: TimerHandler,
      timeout?: number,
      ...args: any[]
    ): number {
      if (typeof handler === 'function') {
        if (stopAnimationsToggle.checked && timeout && timeout >= 200 && timeout <= 5000) {
          return originalSetTimeout(() => {
            handler(...args);
          }, 0);
        }
        return originalSetTimeout(handler, timeout, ...args);
      }
      return originalSetTimeout(handler, timeout, ...args);
    };
    toggleStateText.innerText = a11ySettings[moduleName] ? 'aktiviert' : 'deaktiviert';
    if (a11ySettings[moduleName]) {
      stopAnimationsToggle.checked = a11ySettings[moduleName];
      toggleVideos(stopAnimationsToggle.checked);
      document.body.classList.toggle("a11y-paused", stopAnimationsToggle.checked);
    }
    return styleContents;
  }

  reset() {
    const toggle = document.getElementById('toggle-stop-animations') as HTMLInputElement;
    if (toggle) {
      toggle.checked = false;
      toggle.dispatchEvent(new Event('change'));
    }
    document.body.classList.remove('a11y-paused');
  }
}

export default new StopAnimationsModule();